import { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';
import CommProfileHeader from '../../Exhibitor/Profile/CommProfileHeader';
import CreateTicketingRequest from './CreateTicketingRequest';
import {
  useDeleteTicketingRequest,
  useGetAllTicketingList,
} from '../apiEndpoints/VisitorApiEndpoints';
import CommonStatus from '../../../Components/Common/CommonStatus';
import PopOver from '../../../Components/PopOver/PopOver';
import { useSearchParams } from 'react-router-dom';

const TicketingRequest = () => {
  const { data, isLoading } = useGetAllTicketingList();
  const { mutate } = useDeleteTicketingRequest();
  const [searchParams, setSearchParams] = useSearchParams();
  const isTicketing = searchParams.get('isTicketing');
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (isTicketing) {
      setToggle(true);
    }
  }, [isTicketing]);
  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add Ticketing Request`}
        listHeadingTitle='Ticketing Request List'
        createBtnText='Add Ticketing'
        toggle={toggle}
        setToggle={(e) => {
          setToggle(e);
          if (e) {
            setSearchParams({ isTicketing: 'available' });
          } else {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('isTicketing');
            setSearchParams(newSearchParams);
          }
        }}
      />
      <div className='profile-right-side px-3 py-3'>
        {toggle ? (
          <CreateTicketingRequest handleClose={() => setToggle(!toggle)} />
        ) : (
          <div className='profile-right-info pt-3 ps-2'>
            {isLoading ? (
              <div className='text-center mt-3'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className='text-center'>SL.</th>
                      <th className='text-center'>Created Date</th>
                      <th className='text-center'>Ticket No.</th>
                      <th className='text-center'>Attend Date</th>
                      <th className='text-center'>Service Name</th>
                      <th className='text-center'>Quantity</th>
                      <th className='text-center'>Price</th>
                      <th className='text-center'>Status</th>
                      <th className='text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {data?.data && data?.data?.length ? (
                        data?.data?.map((sProduct, index) => {
                          return (
                            <tr key={sProduct.id}>
                              <td className='text-center'>{index + 1}</td>
                              <td className='text-center'>
                                {moment(sProduct.created_at).format(
                                  'DD-MMM-YYYY'
                                )}
                              </td>{' '}
                              <td className='text-center'>
                                {sProduct.ticket_no}
                              </td>{' '}
                              <td className='text-center'>
                                {moment(sProduct.date).format('DD-MMM-YYYY')}
                              </td>
                              <td className='text-center'>
                                {sProduct.payment_item_name}
                              </td>
                              <td className='text-center'>
                                {sProduct.quantity}
                              </td>
                              <td className='text-center'>
                                {sProduct.net_total}
                              </td>
                              <td className='text-center'>
                                {CommonStatus(sProduct.status)}
                              </td>
                              <td className='d-flex gap-2 justify-content-center'>
                                <PopOver
                                  confirm={() => {
                                    mutate(sProduct.id);
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className='text-center'>
                          <td colSpan={7} className='fw-bold'>
                            No data found
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default TicketingRequest;
